import { configureStore } from "@reduxjs/toolkit";

import axios from "axios";
import productFinderSlice from "./slices/ProductFinder/ProductFinderSlice";
import orderSlice from "./slices/OrderSlice/OrderSlice";
import customerSlice from "./slices/CustomerSlice/CustomerSlice";
import loadingTracker from "./slices/LoadingSlice/LoadingSlice";
import cartSlice from "./slices/CartSlice/CartSlice";
import adminSlice from "./slices/AdminSlice/AdminSlice";

/**
 * Catch all network request errors
 */
const queryErrorLogger = () => (next) => (action) => {
  return next(action);
};

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  config.headers["source"] = "REACTAPP";

  return config;
});

export default configureStore({
  reducer: {
    productFinder: productFinderSlice,
    orders: orderSlice,
    customer: customerSlice,
    loadingTracker: loadingTracker,
    cart: cartSlice,
    admin: adminSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(queryErrorLogger),
});
